import React from 'react';
import { SHAPE } from '../interfaces';
export const SeatingViewerContext = React.createContext(null);
//# sourceMappingURL=seating-viewer-context.js.map